NODE_CONTENT_TYPE_SERIES